// Import styles - this will be separated in webpack by default
import '../sass/style.scss';
import './components/accordion';
import './components/sliders';
import './components/information-bar';
import './components/remove-lazy-load';
import './components/sticky-menu';
import './modules/video';
import './components/qala-filter';
import './modules/newsletter';
import './modules/cta-popup';
import './components/cookie-fix';
import './components/gtm-tracking';
import './components/redirect-popup';
import objectFitImages from 'object-fit-images';
import 'objectFitPolyfill/dist/objectFitPolyfill.basic.min';
import './modules/secondary-menu';
import './modules/contact-us-updates';
import './components/show-hide';
import Menu from './navigation/menu.js';

// run objectfit logic.
objectFitImages();

// Instantiate the menu logic.
new Menu();

jQuery( $ => {
	//require( './navigation/ac-mobile-menu' );
	//require( './navigation/ac-menu' );

	$( '[data-search-toggle]' ).on( 'click', function() {
		$( this ).toggleClass( 'search-open' );
		$( '.sub-menu-container' ).removeClass( 'open' );

		$( this ).attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );

		$( '#search-container' ).slideToggle( 150, function() {
			$( this ).find( '.form-control' ).focus();
		} );
	} );

	/**
	 * Generic back button functionality.
	 */
	$( '.js-back-button' ).click( e => {
		e.preventDefault();
		// Equal to clicking the back button in the browser.
		window.history.back();
	} );

	/**
	 * Scroll to id
	 *
	 * @param {string} target is the target id
	 */
	$( 'a[href^="#"]' ).not( '[href="#"]' ).on(
		'click',
		function( e ) {
			const target = $( this.hash );
			if ( 0 === target.length ) {
				return;
			}
			const makeSticky = $( '.secondary-menu-wrapper' ).hasClass( 'sticky-menu' );
			if ( makeSticky ) {
				e.preventDefault();
				$( 'body, html' ).animate( {
					scrollTop: target.offset().top - 150,
				}, 1000 );
			} else {
				e.preventDefault();
				$( 'body, html' ).animate( {
					scrollTop: target.offset().top - 80,
				}, 1000 );
			}
		} );

	$( document ).ready( function() {
		if ( $( window ).width() < 992 ) {
			$( '.table-wrapper tbody tr>td:first-of-type' ).each( function() {
				if ( $( this ).closest( '.table-wrapper' ).hasClass( 'unlocked-column' ) ) {
					return;
				}
				const elementHeight = $( this ).next( 'td' ).outerHeight();

				$( this ).parent( 'tr' ).css( 'height', elementHeight + 'px' );
				$( this ).css( 'height', ( elementHeight + 1 ) + 'px' );
				$( this ).css( 'position', 'absolute' );
			} );
		}
	} );
} );
